import React, { useState, useEffect } from 'react';
import { Layout } from '../Components/Layout';
import {
  setDrawerContent,
  setPageContent,
  hideDrawer,
} from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';
import { selectMusic } from '../Store/SpotDetails/Actions';
import { DetailsTelevisionContent } from '../Components/Details/ContentTelevision';
import { DetailsRadioContent } from '../Components/Details/ContentRadio';

interface IPropsFromState {
  router: RouterState;
}

interface IPropsFromDispatch {
  setDrawerContent: typeof setDrawerContent;
  setPageContent: typeof setPageContent;
  hideDrawer: typeof hideDrawer;
  selectMusic: typeof selectMusic;
}

type AllProps = IPropsFromState &
  IPropsFromDispatch &
  RouteComponentProps<{}> &
  IConnectedReduxProps;

const DetailsPage: React.FC<AllProps> = (props) => {
  const [bucketId, setBucketId] = useState<number>(0);
  const [fgpId, setFgpId] = useState<number>(0);

  const extractIdFromPath = (pathname: string) => {
    const ids = pathname.match(/\d+/g);
    if (ids && ids.length === 2) {
      const bucketId = parseInt(ids[0], 10);
      const fgpId = parseInt(ids[1], 10);
      if (bucketId && fgpId) {
        return { bucketId, fgpId };
      }
    }
    return null;
  };

  const pathState = extractIdFromPath(props.router.location.pathname);
  const pathBase = props.router.location.pathname.split('/')[1];

  useEffect(() => {
    props.hideDrawer();

    if (pathState) {
      props.selectMusic(pathState.fgpId.toString());
      setBucketId(pathState.bucketId);
      setFgpId(pathState.fgpId);
    }
  }, [props.router.location.pathname, props.hideDrawer, props.selectMusic]);

  useEffect(() => {
    if (bucketId !== 0 && fgpId !== 0) {
      if (pathBase === 'details-television') {
        props.setPageContent(
          <Route
            component={(props: any) => (
              <DetailsTelevisionContent
                {...props}
                bucketId={bucketId}
                fgpId={fgpId}
              />
            )}
          />
        );
      } else if (pathBase === 'details-radio') {
        props.setPageContent(
          <Route
            component={(props: any) => (
              <DetailsRadioContent
                {...props}
                bucketId={bucketId}
                fgpId={fgpId}
              />
            )}
          />
        );
      } else {
        props.setPageContent(<></>);
      }
    }
  }, [bucketId, fgpId, props.setPageContent]);

  if (bucketId === 0 || fgpId === 0) {
    return <Route component={() => <div>Not Found</div>} />;
  }

  return (
    <Route
      component={(props: any) => <Layout {...props} hideAppBarDrawerIcon />}
    />
  );
};

const mapStateToProps = ({ router }: IApplicationState) => ({
  router,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
  setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
  hideDrawer: () => dispatch(hideDrawer()),
  selectMusic: (id: string | null) => dispatch(selectMusic(id)),
});

export const Details = connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsPage);
